<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
                <h2 class="h4 m-0 mx-auto"> {{ $t("experience") }} </h2>
            </div>
            <div class="row">
                <div class="sections p-3">
                    <div class="card w-100 border-0">
                        <div class="card-title mb-0">
                            <div class="float-left pt-1">
                                <span class="d-block"> {{ $t("freelancing") }} </span>
                                <span class="d-block"> {{ $t("freelancing_place") }} </span>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("freelancing_date") }} </small>
                                <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                           size="mini" transparent active color="#22333B"
                                           @click="active1=!active1">
                                    <i class='bx bx-link mr-1'></i>
                                    <span class="small-padding-top"> {{ $t("attachment") }} </span>
                                </vs-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">
                                <section class="text-dark ltr">
                                    <small> #Backend </small>
                                    <small> #Frontend </small>
                                </section>
                            </div>
                            <div class="float-right">

                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-4">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-1">
                                    <img src="@/assets/images/neshan.png" class="place-logos" alt="neshan">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{
                                                $t("tech_lead")
                                            }} <small>({{ $t("full_time") }})</small> </span>
                                        <span class="d-block" v-html="$t('neshan')"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <small> {{ $t("neshan_date") }} </small>
                                <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                           size="mini" transparent active color="#22333B"
                                           @click="active4=!active4">
                                    <i class='bx bx-link mr-1'></i>
                                    <span class="small-padding-top"> {{ $t("attachment") }} </span>
                                </vs-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">
                                <section class="text-muted ltr">
                                    <small> <a href="https://www.java.com/en" class="text-dark" target="_blank">
                                        #Java </a> </small>
                                    <small> <a href="https://spring.io/projects/spring-boot" class="text-dark"
                                               target="_blank"> #Spring_Boot </a> </small>
                                </section>
                            </div>
                            <div class="float-right">
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="company-positions mt-3">
                            <div class="position-item">
                                <span>{{ $t("tech_lead") }}</span>
                                <div class="small">{{ $t("neshan_tech_date") }}</div>
                                <div class="position-description mt-1" :class="{ truncated: !showNeshanFull }">
                                    <span v-if="!showNeshanFull" class="small">
                                        {{ $t('neshan_tech_desc').slice(0, 145) }}
                                        <a href="javascript:void(0)" @click="showNeshanFull = true" class="see-more"> {{ $t('more') }} </a>
                                    </span>
                                    <span v-else class="small">
                                        {{ $t('neshan_tech_desc') }}
                                        <a href="javascript:void(0)" @click="showNeshanFull = false" class="see-more"> {{ $t('less') }} </a>
                                    </span>
                                </div>
                            </div>
                            <div class="position-item">
                                <span>{{ $t("senior_software_engineer") }}</span>
                                <div class="small">{{ $t("neshan_soft_date") }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <vs-button class="d-inline mt-3" transparent active color="#22333B" data-toggle="collapse" data-target="#collapseExperience" aria-expanded="false" aria-controls="collapseExperience">
                            {{ $t("more") }}
                        </vs-button>
                    </div>
                    <div class="collapse" id="collapseExperience">
                        <div class="card w-100 border-0 mt-3">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-1">
                                        <img src="@/assets/images/quera.jpg" class="place-logos" alt="quera">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("software_engineer") }} <small>({{ $t("full_time") }})</small> </span>
                                            <span class="d-block"> {{ $t("quera") }} </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <div class="ltr">
                                        <small> {{ $t("quera_date") }} </small>
                                    </div>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               size="mini" transparent active color="#22333B"
                                               @click="active3=!active3">
                                        <i class='bx bx-link mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("attachment") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">
                                    <section class="text-muted ltr">
                                        <small> <a href="https://www.python.org" class="text-dark" target="_blank">
                                            #Python </a> </small>
                                        <small> <a href="https://www.php.net" class="text-dark" target="_blank">
                                            #PHP </a> </small>
                                    </section>
                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="position-description mt-1" :class="{ truncated: !showQueraFull }">
                                <span v-if="!showQueraFull" class="small">
                                    {{ $t('quera_desc').slice(0, 170) }}
                                    <a href="javascript:void(0)" @click="showQueraFull = true" class="see-more"> {{ $t('more') }} </a>
                                </span>
                                <span v-else class="small">
                                    {{ $t('quera_desc') }}
                                    <a href="javascript:void(0)" @click="showQueraFull = false" class="see-more"> {{ $t('less') }} </a>
                                </span>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-1">
                                        <img src="@/assets/images/mobintabaran.png" class="place-logos" alt="mobintabaran">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("software_engineer") }} <small>({{ $t("full_time") }})</small></span>
                                            <span class="d-block"> {{ $t("mobintabaran") }} </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right">
                                    <div class="ltr">
                                        <small> {{ $t("mobintabaran_date") }} </small>
                                    </div>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               size="mini" transparent active color="#22333B" @click="active2=!active2">
                                        <i class='bx bx-link mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("attachment") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">
                                    <section class="text-muted ltr">
                                        <small> <a href="https://www.java.com/en" class="text-dark" target="_blank">
                                            #Java </a> </small>
                                        <small> <a href="https://spring.io/projects/spring-boot" class="text-dark"
                                                   target="_blank"> #Spring_Boot </a> </small>
                                    </section>
                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="position-description mt-1">
                                <span class="small"> {{ $t('mobintabaran_desc') }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vs-dialog v-model="active1" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"> Participated in a Lot of Freelancing Projects </li>
                <li class="list-group-item">
                    <a href="https://github.com/abmohajeri" target="_blank"> Open Source Projects </a>
                </li>
                <li class="list-group-item">
                    <a href="https://livey.ir" target="_blank"> Livey </a>
                </li>
                <li class="list-group-item">
                    <a href="https://formy.pages.dev" target="_blank"> Formy </a>
                </li>
            </ul>
        </vs-dialog>

        <vs-dialog v-model="active2" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"> <a href="http://mobintabaran.ir" target="_blank"> mobintabaran.ir </a> </li>
            </ul>
        </vs-dialog>

        <vs-dialog v-model="active3" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"><a href="https://quera.org" target="_blank"> quera.org </a></li>
                <li class="list-group-item"> <a href="https://codecup.ir" target="_blank"> codecup.ir </a> </li>
            </ul>
        </vs-dialog>

        <vs-dialog v-model="active4" :class="{'rtlModal' : this.language === 'fa' }">
            <ul class="list-group list-group-flush p-0 pt-2 text-center">
                <li class="list-group-item"><a href="https://neshan.org" target="_blank"> neshan.org </a></li>
            </ul>
        </vs-dialog>
    </div>
</template>

<script>
    export default {
        name: "Experience",
        data() {
            return {
                language: this.$i18n.locale,
                active1: false,
                active2: false,
                active3: false,
                active4: false,
                showNeshanFull: false,
                showQueraFull: false
            }
        }
    }
</script>

<style>

</style>

<style scoped>
.company-positions {
    position: relative;
}

.position-item {
    position: relative;
    padding-inline-start: 28px;
    padding-bottom: 1.25rem;
}

.position-item:last-child {
    padding-bottom: 0;
}

/* continuous vertical line connecting consecutive dots */
.position-item:not(:last-child)::before {
    content: "";
    position: absolute;
    inset-inline-start: 5px;
    top: 7px;
    bottom: -8px;
    width: 2px;
    background: #d4d9dc;
}

/* timeline dot */
.position-item::after {
    content: "";
    position: absolute;
    inset-inline-start: 0;
    top: 6px;
    width: 12px;
    height: 12px;
    background: #22333B;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 2px rgba(34, 51, 59, 0.15);
    z-index: 2;
}

.position-description {
    white-space: pre-line;
}
</style>
